import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class EnergyManagementService extends Service {
    constructor(axios) {
        super(axios);
        this.setContentTypeHeaderInterceptor();
    }
    /** 스케줄 목록 조회 */
    getScheduleList = async (siteId, scheduleListParam) => {
        const { data } = await this.get(apiWrapper.managerApisV1(`/sites/${siteId}/tou`), scheduleListParam);
        return data;
    };
    /** 스케줄 생성 */
    createScheduleList = async (siteId, siteTOUInfo) => {
        const { data } = await this.post(apiWrapper.managerApisV1(`/sites/${siteId}/tou`), siteTOUInfo);
        return data;
    };
    /** 프리셋 목록 조회 */
    getPresetList = async (siteId, presetListParam) => {
        const { data } = await this.get(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets`), presetListParam);
        return data;
    };
    /** 프리셋 오퍼레이션 목록 조회 */
    getPresetOperationList = async (siteId, presetId, presetOperationListParam) => {
        const { data } = await this.get(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}/operations`), presetOperationListParam);
        return data;
    };
    /** 프리셋 이름 유효성 검사 */
    validatePresetName = async (siteId, presetNameRequestBody) => {
        const { data } = await this.post(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/name/validate`), presetNameRequestBody);
        return data.body.result;
    };
    /** 프리셋 생성 */
    createPreset = async (siteId, presetNameRequestBody) => {
        const { data } = await this.post(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets`), presetNameRequestBody);
        return data;
    };
    /** 프리셋 삭제 */
    deletePreset = async (siteId, presetId) => {
        const { data } = await this.delete(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}`));
        return data;
    };
    /** 프리셋 이름 수정 */
    patchPresetName = async (siteId, presetId, presetNameRequestBody) => {
        const { data } = await this.patch(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}`), presetNameRequestBody);
        return data;
    };
    /** 프리셋 오퍼레이션 생성 */
    postPresetOperation = async (siteId, presetId, operation) => {
        const { data } = await this.post(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}/operations`), operation);
        return data;
    };
    /** 프리셋 오퍼레이션 수정 */
    putPresetOperation = async (siteId, presetId, operationId, operation) => {
        const { data } = await this.put(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}/operations/${operationId}`), operation);
        return data;
    };
    /** 프리셋 오퍼레이션 목록 삭제 */
    deletePresetOperationList = async (siteId, presetId, operationIdList) => {
        const { data } = await this.post(apiWrapper.managerApisV1(`/sites/${siteId}/tou/presets/${presetId}/operations/delete`), operationIdList);
        return data;
    };
}
